import * as $ from 'jquery';
import LoginPart from 'vtsscheldt/HeaderParts/LoginPart';
import MenuPart from 'vtsscheldt/HeaderParts/MenuPart';
import MobileMenuPart from 'vtsscheldt/HeaderParts/MobileMenuPart';
import SearchPart from 'vtsscheldt/HeaderParts/SearchPart';
import * as i18n from 'CMS/core/i18n';

class Header {
    private global: any;
    private layout: any;
    private lastScroll: any;

    constructor(global: any, layout: any) {
        this.global = global;
        this.layout = layout;
    }
    public initialize() {
        var $root = $('#' + <string>this.layout.r);

        // Internationalisation
        i18n.bind($root);

        var $menuPart = $root.find('.menu-container');
        var menuPart = new MenuPart();
        menuPart.initialize({ root: $menuPart[0] });

        // Only for mobile
        let $searchRoot = $root.find('#mobile-search');
        let searchPart = new SearchPart();
        searchPart.initialize({ root: $searchRoot[0] });

        var $loginRoot = $root.find('.login-container');
        var loginPart = new LoginPart();
        loginPart.initialize({ root: $loginRoot[0], lang: this.global.l });
        
        var $mobileMenuRoot = $root.find('.mobile-menu');
        var mobileMenuPart = new MobileMenuPart();
        mobileMenuPart.initialize({ root: $mobileMenuRoot[0], lang: this.global.l });


        $(window).bind('scroll', () => {
            this.checkStick();
        });
        $(window).on('resize', () => {
            this.checkStick();
        });

        this.checkStick();

        // Mobile: only one dropdown collapsed at a time
        $root.find('#mobile-login-toggle').click(e => {
            (<any>$root.find('#mobile-search')).collapse('hide');
        });

        // Mobile: only one dropdown collapsed at a time
        $root.find('#mobile-search-toggle').click(e => {
            (<any>$root.find('#mobile-login')).collapse('hide');
        });

        // Mobile menu
        $root.find('.col-menu-list-overlay').on('click', (e) => {
            $root.find('.col-menu-list').addClass('collapsed');
            $root.find('.col-menu-list-overlay').addClass('hidden');
        });

        $root.find('#mobile-menu-toggle').on('click', (e) => {
            e.preventDefault();
            $root.find('.col-menu-list').removeClass('collapsed');
            $root.find('.col-menu-list-overlay').removeClass('hidden');
        });
    }

    public checkStick() {
        let currentScrollPos = $(window).scrollTop();
        let vlHeaderHeight = 0;
        let menuHeight = 51;

        if ($(window).width() < 992) {
            this.resetStick();
            return;
        }

        var vtsScheldtHeader = $('.vtsscheldt-header').outerHeight(true);
        if (currentScrollPos > (vtsScheldtHeader - menuHeight) + vlHeaderHeight) {

            const $menuContainer = $('.menu-container');
            $menuContainer.addClass('stick');
            $menuContainer.parent().addClass('sticky-child');           
            
        }

        if ((currentScrollPos < (vtsScheldtHeader - menuHeight + vlHeaderHeight)) && this.lastScroll > currentScrollPos) {
            this.resetStick();
        }

        this.lastScroll = currentScrollPos;
    }
   
    public resetStick() {
        const $menuContainer = $('.menu-container');
        $('.vl-header.stickify').removeClass('stick');
        $menuContainer.removeClass('stick');
        $menuContainer.parent().removeClass('sticky-child');
        $('.main-wrapper').css('padding-top', '0');
    }
    public destroy() {

    }

}
export = Header;/* Export the class  */


